
export enum SubmissionFilter {
    All,
    ReportedIssues,
    IssueComments,
    ReportedFurniture,
    AwaitingReviewSortedBySubmissionDate,
    AwaitingReviewSortedByParish,
    AwaitingReviewPublicSortedByName,
    AwaitingReviewVolunteerSortedByName,
    RejectedInLastMonthSortedByDate,
    AcceptedInLastMonthSortedByDate
}


